/**
 * title: XXX
 */
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'umi';
// import { useIntl } from 'umi';
// import { useDispatch, useSelector } from 'dva';
// import { Button } from 'antd';
// import styles from './index.less?modules';
import HomePage from 'PAGES/ec/dashbord/index';

const Home = () => {
  // const intl = useIntl();

  // Home.title = intl.formatMessage(
  //   {
  //     id: 'ste.title',
  //     defaultMessage: 'ddd',
  //   },
  //   {
  //     name: 'rrr',
  //   },
  // );

  // const dispatch = useDispatch();

  // const loadingEffect = useSelector((state) => state.loading);
  // const loading = loadingEffect.effects['common/fetchUser'];
  // const [bizData, setBizData] = useState(null);

  // 发起请求
  // useEffect(() => {
  //   dispatch({
  //     type: 'common/fetchUser',
  //     payload: {
  //       values: {
  //         username: 'uuu',
  //         password: '000000',
  //       },
  //     },
  //     callback: (data) => {
  //       setBizData(data);
  //       console.table(data);
  //     },
  //   });
  // }, [dispatch]);

  // 渲染页面
  // console.table(user);
  // if (loading || !bizData) {
  //   return <div>loading...</div>;
  // }
  return <HomePage />;
};

Home.title = 'homepage.title';

export default Home;
